var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5002 13.9999C11.9479 13.9999 11.5002 13.5522 11.5002 12.9999V9.99988C11.5002 9.4476 11.9479 8.99988 12.5002 8.99988C13.0525 8.99988 13.5002 9.4476 13.5002 9.99988V12.9999C13.5002 13.5522 13.0525 13.9999 12.5002 13.9999Z",
    fill: "#FFBA33"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0002 16.4999C11.0002 15.6715 11.6717 14.9999 12.5002 14.9999C13.3286 14.9999 14.0002 15.6715 14.0002 16.4999C14.0002 17.3283 13.3286 17.9999 12.5002 17.9999C11.6717 17.9999 11.0002 17.3283 11.0002 16.4999Z",
    fill: "#FFBA33"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7303 3.21548C11.4802 1.79081 13.5202 1.7908 14.27 3.21548L22.6136 19.0684C23.3146 20.4002 22.3488 21.9999 20.8438 21.9999H4.15653C2.65151 21.9999 1.68574 20.4002 2.3867 19.0684L10.7303 3.21548ZM20.8438 19.9999L12.5002 4.14697L4.15653 19.9999L20.8438 19.9999Z",
    fill: "#FFBA33"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarning);
export default __webpack_public_path__ + "static/media/icon_warning.03698e657ff93d0315237530b2f7ce75.svg";
export { ForwardRef as ReactComponent };